module.exports = __webpack_public_path__ + "img/task-4.710032cb.png";